import { Button, Grid, IconButton, styled, TextField } from '@mui/material';
import React from 'react';
import ClearSharpIcon from '@mui/icons-material/ClearSharp';
import { useTranslation } from 'react-i18next';
import { ManualInfo } from '../EditTypeModal';
import FolderIcon from '@mui/icons-material/Folder';
import { ACCEPT_TYPE_MANUAL } from '../../../../../_constants/manageConst';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

type DisplayManualProps = {
  manualInfo: ManualInfo;
  handleChange: (file: File | null) => void;
};

const DisplayManual: React.FC<DisplayManualProps> = ({
  manualInfo,
  handleChange,
}) => {
  const { t } = useTranslation();

  const onChangeFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) {
      return;
    }
    handleChange(file);
  };

  return (
    <React.Fragment>
      <Grid
        size={6}
        sx={{
          width: '100%',
          position: 'relative',
        }}
      >
        <IconButton
          onClick={() => handleChange(null)}
          className="hover_delete_icon"
          sx={{
            position: 'absolute',
            right: '-15px',
            top: `calc(-5px - 1rem)`,
            bgcolor: '#FFF',
            display: 'none',
            width: '36px',
            height: '36px',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <ClearSharpIcon />
        </IconButton>
      </Grid>
      <Grid
        size={12}
        container
        justifyContent={'center'}
        alignContent={'center'}
        height={'265px'}
      >
        <Grid size={9} mb={3}>
          <TextField
            fullWidth
            size="small"
            disabled
            placeholder={t('LBL_NO_FILES_SELECTED')}
            value={manualInfo.fileName}
          />
        </Grid>
        <Grid size={9}>
          <Button
            component="label"
            role={undefined}
            variant="contained"
            fullWidth
            sx={{ bgcolor: '#fff', color: '#000', textTransform: 'none' }}
            tabIndex={-1}
            endIcon={<FolderIcon color="primary" />}
          >
            {t('BTN_SELECT_FILE')}
            <VisuallyHiddenInput
              type="file"
              accept={ACCEPT_TYPE_MANUAL}
              onChange={onChangeFile}
            />
          </Button>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default DisplayManual;
